export default __webpack_public_path__ + "static/media/pain.d2108b72.gif";